export default "__VITE_ASSET__a0944b12__"